import { createSlice } from "@reduxjs/toolkit";
import {
  fetchLibrarySongs,
  addLibrarySong,
  removeLibrarySong
} from "./thunk";

export const initialState = {
  librarySongs: [],
  totalItems: 0,
  loading: false,
  error: null,
  success: null,
};

const songLibrarySongSlice = createSlice({
  name: "songLibrarySong",
  initialState,
  reducers: {
    clearLibrarySongMessages: (state) => {
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch library songs
      .addCase(fetchLibrarySongs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLibrarySongs.fulfilled, (state, action) => {
        state.loading = false;
        state.librarySongs = action.payload.items;
        state.totalItems = action.payload.totalItems;
        state.error = null;
      })
      .addCase(fetchLibrarySongs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add song to library
      .addCase(addLibrarySong.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(addLibrarySong.fulfilled, (state, action) => {
        state.loading = false;
        state.librarySongs = [...state.librarySongs, action.payload];
        state.success = 'Song added successfully';
        state.error = null;
      })
      .addCase(addLibrarySong.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = null;
      })

      // Remove song from library
      .addCase(removeLibrarySong.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(removeLibrarySong.fulfilled, (state, action) => {
        state.loading = false;
        state.librarySongs = state.librarySongs.filter(
          (song) => song.id !== action.payload
        );
        state.success = 'Song removed successfully';
        state.error = null;
      })
      .addCase(removeLibrarySong.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = null;
      });
  },
});

export const { clearLibrarySongMessages } = songLibrarySongSlice.actions;

export default songLibrarySongSlice.reducer;
